<template>
  <div id="pagetop" @click="backToTop">
    <tk-link>ページ上部へ戻る▲</tk-link>
  </div>
</template>

<script>
import { TkLink } from '@ota-frontend/ui'

export default {
  name: 'TkHotelScrollToTop',
  components: {
    TkLink,
  },
  mounted() {
    window.smoothScroll = () => {
      const currentScrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      if (currentScrollTop > 0) {
        window.requestAnimationFrame(window.smoothScroll)
        window.scrollTo(
          document.documentElement.scrollLeft || document.body.scrollLeft,
          0
        )
      }
    }
  },
  methods: {
    backToTop() {
      window.smoothScroll()
    },
  },
}
</script>
